/**
 * YaaS Hooks
 *
 * Hooks for YaaS (Yield-as-a-Service) page functionality
 */

export { useYaasWalletData } from "./useYaasWalletData";
export type { UseYaasWalletDataResult } from "./useYaasWalletData";

export { useYaasStatus } from "./useYaasStatus";

export { useNextDistribution } from "./useNextDistribution";
export type { NextDistribution } from "./useNextDistribution";

export { useRetailEnrollment } from "./useRetailEnrollment";
export type {
    RetailEnrollmentLocalErrorCode,
    RetailEnrollmentRequestError,
    UseRetailEnrollmentResult
} from "./useRetailEnrollment";

export { useYaasSavedDestinations } from "./useYaasSavedDestinations";
export type { CreateSavedDestinationResult, UseYaasSavedDestinationsResult } from "./useYaasSavedDestinations";

export { usePositionSplits } from "./usePositionSplits";
export type {
    PositionSplitInput,
    SetPositionSplitsResponse,
    SetPositionSplitsResult,
    UsePositionSplitsResult
} from "./usePositionSplits";

export { useDistributionMode } from "./useDistributionMode";
export type { ApiDistributionMode, SetDistributionModeResult, UseDistributionModeResult } from "./useDistributionMode";

export { useWalletVerification, WalletVerificationError } from "./useWalletVerification";
export type {
    VerificationProof,
    VerifyArgs,
    UseWalletVerificationResult,
    WalletVerificationErrorCode
} from "./useWalletVerification";

export { useYaasThresholds } from "./useYaasThresholds";
export type { UseYaasThresholdsResult } from "./useYaasThresholds";

export { useDistributions } from "./useDistributions";
export type { UseDistributionsParams, UseDistributionsResult } from "./useDistributions";

export { useBalanceHistory } from "./useBalanceHistory";
export type { UseBalanceHistoryParams, UseBalanceHistoryResult } from "./useBalanceHistory";

// Helpers (for custom transformations)
export { transformPosition, transformWalletStats, getEarliestPositionDate } from "./helpers";
